import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startSending, endSending } from "../progress/pogressSlice";
import { serverErrors } from "../";
import * as api from '../../api';

const initialState = {
    isAuth: false,
    profile: {},
    type: '',
    user: ''
}
 
export const login = createAsyncThunk('/auth/login', async ( {values, setError, navigate}, thunkAPI ) => {
    thunkAPI.dispatch(startSending());
    try {
        const { data } = await api.auth(values);
        api.setToken(data.token);
        localStorage.setItem('token', data.token)
        thunkAPI.dispatch(endSending());
        navigate('/perfil')
        return data   
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError))
        return thunkAPI.rejectWithValue();
    }
})

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logOut: (state) => {
            localStorage.clear()
            return initialState
        }
    },
    extraReducers(builder){
        builder
            .addCase(login.fulfilled, (_, action) => {
                return { isAuth: true, ...action.payload }
            })
    }
})

export const { logOut } = authSlice.actions;

export default authSlice.reducer;